// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__e5Qq5","label":"styles_label__3_cdl"};